/**
 * Pola NIP: 10 cyfr albo format UE (2 litery kraju + 10 cyfr), np. PL6792592567.
 * Prefiks i litery wymuszane jako wielkie; zapis/GUS i tak normalizuje do 10 cyfr.
 */

const NIP_MAX_LEN = 12; // 2 litery kraju + 10 cyfr

/**
 * @param {string} raw
 * @returns {string} znormalizowany wpis (np. "PL6792592567" albo "6792592567")
 */
function extractNipDigits(raw) {
    const upper = String(raw || '').toUpperCase();
    // Tylko litery i cyfry — bez spacji/myślników w polu (czytelniej przy maxlength 12).
    const cleaned = upper.replace(/[^A-Z0-9]/g, '');

    let prefix = '';
    let i = 0;
    while (i < cleaned.length && i < 2 && /[A-Z]/.test(cleaned[i])) {
        prefix += cleaned[i];
        i += 1;
    }

    const digits = cleaned.slice(i).replace(/\D/g, '').slice(0, 10);

    return prefix + digits;
}

function bindNipInput(input) {
    if (!input || input.dataset.nipDigitsBound === '1') {
        return;
    }
    input.dataset.nipDigitsBound = '1';

    input.setAttribute('inputmode', 'text');
    input.setAttribute('maxlength', String(NIP_MAX_LEN));
    // Brak standardowego tokenu HTML dla NIP — `on` pozwala przeglądarce
    // podpowiadać zapamiętane wartości (name/id/etykieta „nip”).
    input.setAttribute('autocomplete', input.getAttribute('autocomplete') || 'on');
    input.setAttribute('spellcheck', 'false');
    input.style.textTransform = 'uppercase';

    const restrict = () => {
        const normalized = extractNipDigits(input.value);
        if (input.value !== normalized) {
            input.value = normalized;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));

            const wireModel =
                input.getAttribute('wire:model') ||
                input.getAttribute('wire:model.live') ||
                input.getAttribute('wire:model.defer') ||
                input.getAttribute('wire:model.blur');
            if (wireModel && window.Livewire) {
                const root = input.closest('[wire\\:id]');
                const component = root && window.Livewire.find(root.getAttribute('wire:id'));
                if (component) {
                    component.set(wireModel, normalized);
                }
            }
        }
    };

    input.addEventListener('input', restrict);
    input.addEventListener('blur', restrict);
}

function initNipDigits(root = document) {
    root.querySelectorAll(
        'input[name="nip"], input[name$=".nip"], input[id="nip"], input[id^="nip_"], input.js-nip-digits'
    ).forEach(bindNipInput);
}

module.exports = {
    initNipDigits,
    bindNipInput,
    extractNipDigits,
};
